import React from "react";

import Profile from "../Profile";
import SocialLinks from "../SocialLinks";

import * as S from "./styles";

const Sidebar = () => (
  <S.SidebarWrapper>
    <Profile />
    <SocialLinks />
    <S.DevelopedBy>
      Desenvolvido com{" "}
      <a
        href="https://www.gatsbyjs.org/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Gatsby
      </a>
    </S.DevelopedBy>
  </S.SidebarWrapper>
);

export default Sidebar;
